import { Route, Switch } from 'react-router-dom';
import MenuManager from '@yooink/youtils/es/MenuManager';
import PropTypes from 'prop-types';
import { useLoadComponent } from '@yooink/youtils/es/hooks/useLoadComponent';
import { BiUserVoice } from 'react-icons/bi';

/*MenuManager.RegisterItem({
	/!*key: 'Leads',*!/
	name: 'Лиды',
	path: '/leads',
	icon: <BiUserVoice />,
	position: 3
})*/

const LeadsRoute = (props) => {
	const basePath = props.path || '/leads';
	const getPath = (path = '') => `${basePath}${path}`;

	const List = useLoadComponent(() => import('./List'), {
		basePath
	});
	const View = useLoadComponent(() => import('./View'), {
		basePath
	});

	const LeadForms = useLoadComponent(() => import('./LeadForms/LeadFormsRoute').then((m) => m.LeadFormsRoute), {
		path: getPath('/forms')
	});

	return (
		<>
			<Route
				exact
				path={getPath()}
				component={List}
			/>
			<Switch>
				<Route
					path={getPath('/forms')}
					component={LeadForms}
				/>
				<Route
					exact
					path={getPath('/:id')}
					component={View}
				/>
			</Switch>
		</>
	);
};

LeadsRoute.propTypes = {
	path: PropTypes.string
};

export { LeadsRoute };
